module.exports = __webpack_public_path__ + "static/media/DSC_2715-Pano.2105d31b.jpg";